var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFarcaster = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.888 2H4.778v2.285h11.11V2Zm2.223 14.285v.572h-4.444v-.572c0-.315.249-.571.556-.571V6.572v4.525c0-2.209-1.742-4-3.89-4-2.13 0-3.861 1.763-3.888 3.948v4.669c.307 0 .555.256.555.571v.572H2.556v-.572c0-.315.248-.571.555-.571V6.572h-.555L2 4.286h16.667l-.556 2.286h-.555v9.142c.307 0 .555.256.555.571Zm.556 1.144a.564.564 0 0 0-.556-.572h-4.444a.564.564 0 0 0-.556.572V18h5.556v-.571ZM7 16.857c.307 0 .556.256.556.572V18H2v-.571c0-.316.249-.572.556-.572H7Z",
  clipRule: "evenodd"
})));
export default SvgFarcaster;